export function isEmailBlacklisted(email: string) {
  return email.toLowerCase().includes('@sgul.ac.uk');
}
